import { connect } from 'react-redux';

import AppI18nProvider from '../../shared/components/app_i18n_provider';

const mapStateToProps = state => ({
  locale: state.getIn(['explorer','locale'])
});

export default connect(mapStateToProps)(AppI18nProvider);
